export default __webpack_public_path__ + "static/media/commission-plan.2d37fbf3.svg";